import { render, staticRenderFns } from "./RDataCategoryCard.vue?vue&type=template&id=1db48adc&scoped=true&"
import script from "./RDataCategoryCard.vue?vue&type=script&lang=js&"
export * from "./RDataCategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./RDataCategoryCard.vue?vue&type=style&index=0&id=1db48adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db48adc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
